import React, { useEffect, useState } from 'react'
import { Button, Col, Form, Modal, Row } from 'react-bootstrap'
import { EyeCloseSvg, EyeSvg, RefreshSvg } from '../../assets/svgs/Svg'

const ForgotPassword = (props) => {
  const { forgotPasswordModal, gobackToLogin, refreshCaptcha,
    code, setCode, forgotPasswordFormData, handleChange,
    callingPasswordForgotAPI, showOTPField, showNewPasswordField,
    callingAPItype } = props

  const [showPassword, setShowPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)

  const handleTogglePasswordVisibility = (type) => {
    switch (type) {
      case "password":
        setShowPassword(!showPassword);
        return
      case "confirmPassword":
        setShowConfirmPassword(!showConfirmPassword)
        return
      default:
        return
    }
  };

  useEffect(() => {
    refreshCaptcha()
  }, [])

  return (
    <>
      <div
        className="page"
        style={{
          backgroundImage: `url("./assets/Images/LoginbackgroundImage3.png")`,
          backgroundPosition: "center",
          backgroundSize: "100% 100%",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="page-single">
          <div className="container">
            <Row>
              <Col
                xl={5}
                lg={6}
                md={8}
                sm={10}
                xs={12}
                className="card-sigin-main mx-auto my-auto py-4 justify-content-center"
              >
                <div className="card-sigin">
                  {/* <!-- Demo content--> */}
                  <div className="main-card-signin d-md-flex">
                    <div className="wd-100p">
                      <div className="d-flex mb-4"></div>
                      <div className="">
                        <div className="main-signup-header">
                          <h2 className="text-center">Welcome To Falconfly DashbaordF</h2>
                          <h6 className="font-weight-bold mb-4 text-center">
                            Please enter mobile number
                          </h6>
                          <div className="panel panel-primary">
                            <div className=" tab-menu-heading mb-2 border-bottom-0">
                              <div className="tabs-menu1">
                                <Form
                                  onSubmit={callingPasswordForgotAPI}
                                >
                                  {
                                    !showNewPasswordField &&
                                    <Form.Group className="form-group">
                                      <Form.Label className="">
                                        Mobile Number
                                      </Form.Label>{" "}
                                      <Form.Control
                                        className="form-control"
                                        placeholder="Enter 10 digit mobile number"
                                        value={forgotPasswordFormData?.phonenumber}
                                        name="phonenumber"
                                        type="text"
                                        maxLength={10}
                                        pattern="[1-9]{1}[0-9]{9}"
                                        title="Enter 10 digit mobile number"
                                        onChange={handleChange}
                                        required
                                      />
                                    </Form.Group>
                                  }

                                  {
                                    showNewPasswordField &&
                                    <>
                                      <Form.Group className="form-group" style={{ position: "relative" }}>
                                        <Form.Label className="">
                                          New Password
                                        </Form.Label>{" "}
                                        <Form.Control
                                          className="form-control"
                                          placeholder="Enter new password"
                                          value={forgotPasswordFormData?.newpassword}
                                          name="newpassword"
                                          type={showPassword ? 'text' : 'password'}
                                          onChange={handleChange}
                                          required
                                        />
                                        <div onClick={()=>handleTogglePasswordVisibility("password")}>
                                        {
                                          showPassword ? <EyeSvg className=""
                                            style={{
                                              position: "absolute",
                                              right: "12px",
                                              top: "38px",
                                              cursor:"pointer"
                                            }} />
                                            :
                                            <EyeCloseSvg className=""
                                              style={{
                                                position: "absolute",
                                                right: "12px",
                                                top: "38px",
                                                cursor:"pointer"
                                              }} />
                                        }
                                        </div>
                                        {/* <i className={showPassword ? 'mg-t-2 bx bx-show eyeIcon' : 'mg-t-2 bx bx-low-vision eyeIcon'} onClick={() => handleTogglePasswordVisibility("password")}></i> */}
                                      </Form.Group>
                                      <Form.Group className="form-group" style={{ position: "relative" }}>
                                        <Form.Label className="">
                                          Confirm Password
                                        </Form.Label>{" "}
                                        <Form.Control
                                          className="form-control"
                                          placeholder="Reenter password"
                                          value={forgotPasswordFormData?.confirmpassword}
                                          name="confirmpassword"
                                          type={showConfirmPassword ? 'text' : 'password'}
                                          onChange={handleChange}
                                          required
                                        />
                                        <div onClick={()=>handleTogglePasswordVisibility("confirmPassword")}>
                                        {
                                        showPassword ? <EyeSvg className=""
                                          style={{
                                            position: "absolute",
                                            right: "12px",
                                            top: "38px",
                                            cursor:"pointer"
                                          }} />
                                          :
                                          <EyeCloseSvg className=""
                                            style={{
                                              position: "absolute",
                                              right: "12px",
                                              top: "38px",
                                              cursor:"pointer",
                                            }} />
                                      }
                                        </div>
                                      </Form.Group>
                                      
                                      {/* <i className={showConfirmPassword ? 'mg-t-80 bx bx-show eyeIcon' : 'mg-t-80 bx bx-low-vision eyeIcon'} onClick={() => handleTogglePasswordVisibility("confirmPassword")}></i> */}
                                    </>
                                  }
                                  {
                                    showOTPField &&
                                    <Form.Group className="form-group">
                                      <Form.Label className="">
                                        Enter OTP
                                      </Form.Label>{" "}
                                      <Form.Control
                                        className="form-control"
                                        placeholder="Enter OTP"
                                        value={forgotPasswordFormData?.otp}
                                        name="otp"
                                        type="text"
                                        // pattern="[1-9]{1}[0-9]{9}"
                                        // title="Enter number" 
                                        onChange={handleChange}
                                        required
                                      />
                                    </Form.Group>
                                    // :
                                    // callingAPItype === "Reset password" ?
                                    //   <></>
                                    //   :
                                    // <Form.Group className="form-group">
                                    //   <Row className="row">
                                    //     <Col sm={12}>
                                    //       <Row className="row-lg d-flex align-items-center">
                                    //         <Col
                                    //           lg={4}
                                    //           className="d-flex align-items-center"
                                    //         >
                                    //           <div
                                    //             id="captcha"
                                    //             className="d-inline-block me-1"
                                    //           ></div>
                                    //           <div
                                    //             onClick={refreshCaptcha}
                                    //             style={{ cursor: "pointer" }}
                                    //           >
                                    //             <RefreshSvg
                                    //               className="fe fe-refresh-ccw "
                                    //               title="fe fe-refresh-ccw"
                                    //             />

                                    //           </div>
                                    //         </Col>
                                    //         <Col className="mg-t-10 mg-sm-t-0 w-100 ">
                                    //           <Form.Control
                                    //             className="form-control"
                                    //             placeholder="Enter Captcha"
                                    //             name="text"
                                    //             type="text"
                                    //             value={code}
                                    //             autoComplete="off"
                                    //             onChange={(e) =>
                                    //               setCode(e.target.value)
                                    //             }
                                    //             required
                                    //           />
                                    //         </Col>
                                    //       </Row>
                                    //     </Col>
                                    //   </Row>
                                    // </Form.Group>
                                  }
                                  <Form.Group className="form-group">
                                    <Row className="row">
                                      <Col sm={12}>
                                        <Row className="row-lg d-flex align-items-center">
                                          <Col
                                            lg={4}
                                            className="d-flex align-items-center"
                                          >
                                            <div
                                              id="captcha"
                                              className="d-inline-block me-1"
                                            ></div>
                                            <div
                                              onClick={refreshCaptcha}
                                              style={{ cursor: "pointer" }}
                                            >
                                              <RefreshSvg
                                                className="fe fe-refresh-ccw "
                                                title="fe fe-refresh-ccw"
                                              />

                                            </div>
                                          </Col>
                                          <Col className="mg-t-10 mg-sm-t-0 w-100 ">
                                            <Form.Control
                                              className="form-control"
                                              placeholder="Enter Captcha"
                                              name="text"
                                              type="text"
                                              value={code}
                                              autoComplete="off"
                                              onChange={(e) =>
                                                setCode(e.target.value)
                                              }
                                              required
                                            />
                                          </Col>
                                        </Row>
                                      </Col>
                                    </Row>
                                  </Form.Group>

                                  <Button
                                    variant=""
                                    type="submit"
                                    className="btn btn-primary btn-block"
                                  // disabled={btndisabled}
                                  // onClick={movetodashboardpage}
                                  >
                                    {callingAPItype}
                                  </Button>
                                  <Form.Label className="d-flex justify-content-center">
                                    Remember your password ?
                                    <p role="button" className='ms-1' onClick={() => gobackToLogin()}>
                                      Login here!
                                    </p>
                                  </Form.Label>{" "}
                                </Form>
                              </div>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </>
  )
}

export default ForgotPassword